import PropTypes from 'prop-types';
import {useNavigate} from "react-router-dom";

import Container from '@mui/material/Container';
import PasswordIcon from '@mui/icons-material/Password';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import HistoryIcon from '@mui/icons-material/History';
import PaymentsIcon from '@mui/icons-material/Payments';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import Stack from "@mui/material/Stack";

import './PatientSettingsMenu.scss';
import MenuWidget from "../common/MenuWidget";

const PatientSettingsMenu = props => {
  const {patientId} = props;
  const navigate = useNavigate();
  const menuItems = [
    {
      title: 'Account Info',
      Icon: AccountBoxIcon,
      onClick: () => navigate(`/clients/view/${patientId}?excludeMedicalHistory=true`),
    },
    // {
    //   title: 'Medical History',
    //   Icon: HistoryIcon,
    //   onClick: () => navigate(`/clients/view/${patientId}?excludeAccountInfo=true`),
    // },
    {
      title: 'Payments',
      Icon: PaymentsIcon,
      onClick: () => navigate('/clients/settings/payments'),
    },
    {
      title: 'Reset Password',
      Icon: PasswordIcon,
      onClick: () => navigate(`/reset-password/start`),
    },
    // {
    //   title: 'Insurance',
    //   Icon: MedicalInformationIcon,
    //   onClick: () => navigate(`/clients/settings/insurance`),
    //   isBeta: true,
    // }
  ];
  return (
    <Container className='PatientSettingsMenu' maxWidth='xl' style={{paddingTop: '3em',}}>
      <Stack direction='row' spacing={{ xs: 2, lg: 4 }} useFlexGap flexWrap='wrap' justifyContent='center'>
        {
          menuItems
            .map(s => <MenuWidget className="PatientSettingsMenu__menu" {...s} />)
        }
      </Stack>
    </Container>
  );
};

PatientSettingsMenu.propTypes = {
  providerId: PropTypes.string,
  logout: PropTypes.func,
};

export default PatientSettingsMenu;
